import React from 'react';
import { useLanguage } from '../LanguageContext';
import ywImage from '../assets/images/yw.png';
import fcbImage from '../assets/images/fcb.png';
import fcImage from '../assets/images/fc.png';

const Portfolio = () => {
  const { language } = useLanguage();

  return (
    <section className="bg-custom-hero text-black text-center py-20 px-4">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-10 bg-clip-text text-transparent bg-gradient-to-r from-purple-500 to-pink-500">
          {language === 'id' ? 'Template & Demo Website' : 'Website Templates & Demos'}
        </h2>
        <div className="grid md:grid-cols-3 gap-6">
          {/* Playmakers FC */}
          <div className="bg-white rounded shadow overflow-hidden">
            <img src={fcImage} alt="Soccer Community PlayMakers" className="w-full" />
            <div className="p-4">
              <h3 className="font-bold text-lg">Playmakers FC (Template)</h3>
              <p className="text-sm">
                {language === 'id'
                  ? 'Template situs web pendaftaran klub sepak bola dibuat dengan React.js'
                  : 'Soccer club registration website template built with React.js'}
              </p>
              <a
                href="/blank"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline text-sm mt-2 block"
              >
                {language === 'id' ? 'Lihat Demo' : 'View Demo'}
              </a>
            </div>
          </div>

          {/* Yeni Waliatin Portfolio */}
          <div className="bg-white rounded shadow overflow-hidden">
            <img src={ywImage} alt="Yeni Waliatin Portfolio" className="w-full" />
            <div className="p-4">
              <h3 className="font-bold text-lg">
                {language === 'id' ? 'Portofolio Pribadi' : 'Personal Portfolio'}
              </h3>
              <p className="text-sm">
                {language === 'id'
                  ? 'Website portofolio React saya untuk menampilkan proyek dan keahlian.'
                  : 'My own React portfolio website for showcasing projects and skills.'}
              </p>
              <a
                href="https://yeniwaliatin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline text-sm mt-2 block"
              >
                {language === 'id' ? 'Kunjungi Situs' : 'Visit Site'}
              </a>
            </div>
          </div>

          {/* Fishing Charters Bali */}
          <div className="bg-white rounded shadow overflow-hidden">
            <img src={fcbImage} alt="Fishing Charters Bali" className="w-full" />
            <div className="p-4">
              <h3 className="font-bold text-lg">FishingChartersBali.com</h3>
              <p className="text-sm">
                {language === 'id'
                  ? 'Website untuk operator tur memancing di Bali dengan halaman pemesanan dan info.'
                  : 'Website for Bali-based fishing tour operator with booking and info pages.'}
              </p>
              <a
                href="https://fishingchartersbali.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline text-sm mt-2 block"
              >
                {language === 'id' ? 'Kunjungi Situs' : 'Visit Site'}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
